import React, { useEffect, useState } from 'react';
import { ClockIcon, UsersIcon } from 'lucide-react';
export function Urgency() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem('urgency_countdown_end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining > 0 ? remaining : 6 * 60 * 60;
    }
    const end = Date.now() + 6 * 60 * 60 * 1000;
    localStorage.setItem('urgency_countdown_end', end.toString());
    return 6 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const capacityPercent = 59;
  return <section className="w-full py-16 bg-[#111111] pt-[0px] pb-[0px]" data-id="element-285">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-286">
        <div className="bg-[#1A1A1A] p-8 md:p-12 rounded-lg border border-[#C45C5C]" data-id="element-287">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-288">
            <ClockIcon className="w-10 h-10 text-[#C45C5C]" data-id="element-289" />
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-290">
              Precio de lanzamiento por tiempo limitado
            </h2>
          </div>

          {/* Countdown Timer */}
          <div className="flex justify-center gap-3 md:gap-4 mb-8" data-id="element-291">
            {[{
            value: pad(hours),
            label: 'Horas'
          }, {
            value: pad(minutes),
            label: 'Minutos'
          }, {
            value: pad(seconds),
            label: 'Segundos'
          }].map((unit, i) => <div key={i} className="flex flex-col items-center" data-id="element-292">
                <div className="bg-[#0A0A0A] border border-[#C45C5C]/40 rounded-lg px-4 py-3 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px] text-center" data-id="element-293">
                  <span className="text-3xl md:text-5xl font-bold text-[#C45C5C] font-['Poppins',_sans-serif] tabular-nums" data-id="element-294">
                    {unit.value}
                  </span>
                </div>
                <span className="text-xs text-gray-400 mt-2 uppercase tracking-wider" data-id="element-295">
                  {unit.label}
                </span>
              </div>)}
          </div>

          <p className="text-lg text-gray-300 text-center leading-relaxed mb-6" data-id="element-296">
            Este es el precio más bajo al que va a estar el MegaPack.
          </p>

          <p className="text-center text-gray-400" data-id="element-297">
            No es una táctica: es el precio real de introducción que usamos para
            las primeras compradoras.
          </p>

          {/* Capacity Bar */}
          <div className="mt-8 bg-[#0A0A0A] border border-[#C45C5C]/30 p-5 rounded-lg" data-id="element-298">
            <div className="flex items-center justify-between mb-3" data-id="element-299">
              <div className="flex items-center gap-2" data-id="element-300">
                <UsersIcon className="w-5 h-5 text-[#C45C5C]" data-id="element-301" />
                <span className="text-sm font-semibold text-gray-300" data-id="element-302">
                  Cupos ocupados
                </span>
              </div>
              <span className="text-lg font-bold text-[#C45C5C]" data-id="element-303">
                {capacityPercent}%
              </span>
            </div>
            <div className="w-full bg-[#1A1A1A] rounded-full h-4 overflow-hidden border border-[#2A2A2A]" data-id="element-304">
              <div className="h-full rounded-full bg-gradient-to-r from-[#C45C5C] to-[#D97777] transition-all duration-1000 ease-out" style={{
              width: `${capacityPercent}%`
            }} data-id="element-305" />
            </div>
            <p className="text-xs text-gray-400 mt-2 text-center" data-id="element-306">
              Solo quedan{' '}
              <span className="text-[#D97777] font-semibold" data-id="element-307">
                {100 - capacityPercent}%
              </span>{' '}
              de los cupos disponibles al precio de lanzamiento
            </p>
          </div>
        </div>
      </div>
    </section>;
}